import { useState } from "react";
import { useNavigate } from "react-router-dom";
import QuickQuestion from "../components/QuickQuestion";
import B2CAdvisor from "../components/B2CAdvisor";
import type { TrialResult } from "../lib/api";

/**
 * QuickPage — fokussierter Schnell-Einstieg.
 * Schnellfrage oben, nach Auflösung wird unmittelbar das Verdict gerendert.
 * User kann mit „Vollständig analysieren" zur Detail-Page springen.
 */
export default function QuickPage() {
  const nav = useNavigate();
  const [caseId, setCaseId] = useState<string | null>(null);
  const [caseContext, setCaseContext] = useState<string | undefined>(undefined);
  const [result, setResult] = useState<TrialResult | undefined>(undefined);

  const handleResolved = (id: string, ctx: string, r: TrialResult) => {
    setCaseId(id);
    setCaseContext(ctx);
    setResult(r);
    requestAnimationFrame(() => {
      document.getElementById("verdict")?.scrollIntoView({ behavior: "smooth" });
    });
  };

  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-3xl font-bold tracking-tight">Schnellfrage</h1>
        <p className="mt-2 text-slate-400 max-w-2xl">
          Beschreib deinen Fall in 2-3 Sätzen. Die Mock-Jury liefert in unter 60 Sekunden
          eine Erfolgsaussichts-Einschätzung samt empfohlener Schadenshöhe.
        </p>
      </header>

      <QuickQuestion onResolved={handleResolved} />

      {caseId && result && (
        <section
          id="verdict"
          className="rounded-2xl border border-slate-800 bg-slate-900/40 p-6"
        >
          <div className="flex items-baseline justify-between flex-wrap gap-2 mb-4">
            <h2 className="text-xl font-semibold">Mock Jury Verdict</h2>
            <button
              onClick={() => nav(`/app/case/${caseId}`)}
              className="text-xs rounded-lg border border-slate-700 hover:border-court-500 hover:bg-court-900/30 px-3 py-1.5 transition"
            >
              Vollständig analysieren →
            </button>
          </div>
          <B2CAdvisor caseId={caseId} initialCaseContext={caseContext} initialResult={result} />
        </section>
      )}

      {!caseId && (
        <div className="rounded-xl border border-dashed border-slate-700 bg-slate-950/40 p-8 text-center text-slate-500 text-sm">
          Stelle oben eine Frage. Du brauchst kein PDF und keine Vorbereitung.
        </div>
      )}
    </div>
  );
}
